<template>
  <div ref="chart" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'DualYAxisChart',
  props: {
    title: {
      type: String,
      default: '双Y轴图'
    },
    // xData: {
    //   type: Array,
    //   default: () => []
    // },
    // leftData: {
    //   type: Array,
    //   default: () => []
    // },
    // rightData: {
    //   type: Array,
    //   default: () => []
    // },
    data: {
      type: Object,
      default: () => {}
    },
    leftName: {
      type: String,
      default: '温度 (°C)'
    },
    rightName: {
      type: String,
      default: '湿度 (%)'
    },
    leftColor: {
      type: String,
      default: '#667eea'
    },
    rightColor: {
      type: String,
      default: '#19be6b'
    }
  },
  watch: {
    deep: true,
    data() {
      this.renderChart() // 重置图表
    }
  },
  mounted() {
    setTimeout(() => {
      this.renderChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.chart)
    })
  },
  //   beforeDestroy() {
  //     window.removeEventListener('resize', this.handleResize)
  //     if (this.chart) {
  //       this.chart.dispose()
  //     }
  //   },
  methods: {
    // handleResize() {
    //   if (this.chart) this.chart.resize()
    // },
    renderChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.chart)
      if (mychart == null) mychart = echarts.init(this.$refs.chart)
      console.log(this.data, 'pooooooooooooooooo')
      if (this.data) {
        let xData = []
        let leftData = []
        let rightData = []
        xData = this.data.xData
        leftData = this.data.leftData //比率
        rightData = this.data.rightData

        const total = xData.length
        const showCount = 5 // 默认显示最后6条
        const startIndex = total > showCount ? total - showCount : 0
        const endIndex = total - 1
        const option = {
          // title: { text: this.title },
          // 标题
          title: {
            text: this.title,
            left: 'center',
            top: 15,
            textStyle: {
              fontSize: 16,
              fontWeight: 'normal'
            }
          },
          tooltip: { trigger: 'axis' },
          //   legend: { x: 'right', data: [this.leftName, this.rightName] },
          grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
          xAxis: {
            type: 'category',
            data: xData,
            axisTick: { alignWithLabel: true }
          },
          yAxis: [
            {
              type: 'value',
              name: this.leftName,
              position: 'left',
              axisLine: { lineStyle: { color: this.leftColor } },
              splitLine: { show: false }
            },
            {
              type: 'value',
              name: this.rightName,
              position: 'right',
              axisLine: { lineStyle: { color: this.rightColor } }
            }
          ],
          dataZoom: [
            {
              type: 'slider',
              realtime: true,
              height: 5,
              left: 5,
              right: 5,
              bottom: 10,
              show: total > showCount,
              fillerColor: 'rgba(17, 100, 210, 0.42)',
              borderColor: 'rgba(17, 100, 210, 0.12)',
              handleSize: 0,
              showDetail: false,
              zoomLock: true,
              moveOnMouseMove: false,

              // ✅ 重点设置
              startValue: startIndex,
              endValue: endIndex,
              minValueSpan: showCount,
              maxValueSpan: showCount
            },
            {
              type: 'inside',
              startValue: startIndex,
              endValue: endIndex,
              zoomOnMouseWheel: false,
              moveOnMouseWheel: true,
              moveOnMouseMove: true
            }
          ],
          series: [
            {
              name: this.leftName,
              type: 'line',
              yAxisIndex: 0,
              data: leftData,
              smooth: true,
              itemStyle: { color: this.leftColor }
            },
            {
              name: this.rightName,
              type: 'line',
              yAxisIndex: 1,
              data: rightData,
              itemStyle: { color: this.rightColor }
            }
          ]
        }
        mychart.setOption(option, true)
      }
    }
  }
}
</script>
